import { render, staticRenderFns } from "./PxCamposCompraItemTableSeniorTeixeira.vue?vue&type=template&id=25f73dcd&"
import script from "./PxCamposCompraItemTableSeniorTeixeira.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableSeniorTeixeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports